import { cn } from '@wellesley/ui'
import { FC, PropsWithChildren } from 'react'

import BackButton from '../BackButton'

type TPageHeader = PropsWithChildren & {
  className?: string
}

const PageHeader: FC<TPageHeader> = ({ className, children }) => (
  <div
    className={cn(
      'relative flex w-full items-center justify-center',
      className,
    )}
  >
    <BackButton isText={false} title="Back" className="absolute left-0" />
    {children && (
      <h2 className="text-lg font-semibold text-gray-900">{children}</h2>
    )}
  </div>
)

export default PageHeader
